import { useState } from "react";
import { useEffectOnce } from "@made-people/react-use-effect-once";
import { BffClient } from "@made-people/gears-bff-client";
import { CentraAllocationRuleResponseV1 } from "@made-people/nestjs-bff-service";

export function useAllocationRuleFetch(bffClient: BffClient, market: string) {
  const [allocationRule, setAllocationRule] =
    useState<CentraAllocationRuleResponseV1 | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffectOnce(() => {
    bffClient
      .fetchAllocationRule(market)
      .then((result) => {
        setAllocationRule(result ?? null);
        setIsLoading(false);
      })
      .catch(() => {
        setAllocationRule(null);
        setIsLoading(false);
      });
  });

  return { allocationRule, isLoading };
}
